import { render } from "./captcha.vue?vue&type=template&id=a54ef272&scoped=true"
import script from "./captcha.vue?vue&type=script&lang=js"
export * from "./captcha.vue?vue&type=script&lang=js"

import "./captcha.vue?vue&type=style&index=0&id=a54ef272&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a54ef272"]])

export default __exports__